import * as React from 'react';
import ProductCompareRepository from "../../repository/ProductCompareRepository";
import useReduxState from 'src/hooks/useReduxState';
import { useProductStore } from 'src/hooks/product';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import System from 'src/helper/system';

const ProductCompareClearAll = (props) => {
    const { translation:t } = System;
    const [showNoProductError, setNoProductError] = useReduxState(false, 'setNoProductError');
    const [{ }, { remove_All_Data }, { }] = useProductStore()
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();

    const onClear = async () => {
        await remove_All_Data();
        await new ProductCompareRepository().fetchAllData();
        setNoProductError(true)
        system_alert_indicator({
            name: 'productCompare',
            message: `<b>${t('noCompareProducts')}</b>`,
            type: "info",
            isDisplay: false,
            isDisplayIcon: false
        })
    }

    return (
        <>
            {props.type == 'button' ?
                <button className="bs5 btn btn-secondary"
                    onClick={async () => { onClear(); }} >{t('clearAll')}</button>
                : <a href={'#'} className="compare-clear-link text-uppercase"
                    onClick={async (e) => {
                        e.preventDefault();
                        onClear();
                    }} >{t('clearAll')}</a>
            }
        </>
    );
}

export default ProductCompareClearAll;